<script setup lang="ts">
import wordmark from '../assets/logo-wordmark.svg';

// lg is the default and is used at the top of the AppSidebar (the "main"
// nav logo), in the AppFooter, and on the auth screen headers. sm is the
// reduced size for chromeless headers (checkout, error pages) where the
// logo plays a secondary role next to other top-bar elements.
withDefaults(defineProps<{ size?: 'lg' | 'sm' }>(), { size: 'lg' });
</script>

<template>
  <img
    :src="wordmark"
    alt="GAMZOR"
    draggable="false"
    class="block w-auto select-none"
    :class="size === 'lg' ? 'h-16' : 'h-7'"
  />
</template>
